export default [
  {
    id: 1,
    title: "Mountain View Farmers Market, 600 West Evelyn Ave.,  Mountain View, CA",
    start: new Date(2021, 0, 24, 9, 0, 0, 0),
    end: new Date(2021, 0, 24, 13, 0, 0, 0),
  },
  {
    id: 2,
    title: "Fort Mason Center Farmers Market, Fort Mason Center, Marina Blvd.,  San Francisco, CA",
    start: new Date(2021, 2, 28, 9, 30, 0, 0),
    end: new Date(2021, 2, 28, 13, 30, 0, 0),
  },
  {
    id: 3,
    title: "Saratoga Farmers Market, West Valley College, 14000 Fruitvale Ave.,  Saratoga, CA",
    start: new Date(2021, 3, 3, 9, 0, 0, 0),
    end: new Date(2021, 3, 3, 13, 0, 0, 0),
  },
  {
    id: 4,
    title: "Winters Tavern, 522 Francisco Blvd.,  Pacifica, CA",
    start: new Date(2021, 3, 11, 15, 0, 0, 0),
    end: new Date(2021, 3, 11, 17, 0, 0, 0),
  },
  {
    id: 5,
    title: "Riggers Loft Wine Company, 1325 Canal Blvd.,  Richmond, CA",
    start: new Date(2021, 4, 8, 14, 0, 0, 0),
    end: new Date(2021, 4, 8, 17, 0, 0, 0),
  },
  {
    id: 6,
    title: "The Bistro, 1001 B St., Hayward, CA",
    start: new Date(2021, 1, 27, 14, 0, 0, 0),
    end: new Date(2021, 1, 27, 17, 0, 0, 0),
  },
  {
    id: 7,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2021, 3, 24, 14, 0, 0, 0),
    end: new Date(2021, 3, 24, 17, 0, 0, 0),
  },
  {
    id: 8,
    title: "Auburn Lounge, 321 Hartz Ave. #3336,  Danville, CA",
    start: new Date(2021, 2, 20, 14, 0, 0, 0),
    end: new Date(2021, 2, 20, 17, 0, 0, 0),
  },
  {
    id: 9,
    title: "The Bistro, 1001 B St., Hayward, CA",
    start: new Date(2021, 4, 1, 14, 30, 0, 0),
    end: new Date(2021, 4, 1, 17, 30, 0, 0),
  },
  {
    id: 10,
    title: "Flights Restaurant, 165 Los Gatos-Saratoga Rd. #5306,  Los Gatos, CA",
    start: new Date(2021, 3, 10, 18, 0, 0, 0),
    end: new Date(2021, 3, 10, 21, 0, 0, 0),
  },
  {
    id: 11,
    title: "Flights Restaurant, 165 Los Gatos-Saratoga Rd. #5306,  Los Gatos, CA",
    start: new Date(2021, 3, 17, 18, 0, 0, 0),
    end: new Date(2021, 3, 17, 21, 0, 0, 0),
  },
  {
    id: 13,
    title: "Flights Restaurant, 165 Los Gatos-Saratoga Rd. #5306,  Los Gatos, CA",
    start: new Date(2021, 4, 29, 18, 0, 0, 0),
    end: new Date(2021, 4, 29, 21, 0, 0, 0),
  },
  {
    id: 14,
    title: "Flights Restaurant, 165 Los Gatos-Saratoga Rd. #5306,  Los Gatos, CA",
    start: new Date(2021, 5, 5, 18, 0, 0, 0),
    end: new Date(2021, 5, 5, 21, 0, 0, 0),
  },
  {
    id: 15,
    title: "Flights Restaurant, 165 Los Gatos-Saratoga Rd. #5306,  Los Gatos, CA",
    start: new Date(2021, 6, 10, 18, 0, 0, 0),
    end: new Date(2021, 6, 10, 21, 0, 0, 0),
  },
  {
    id: 16,
    title: "Flights Restaurant, 165 Los Gatos-Saratoga Rd. #5306,  Los Gatos, CA",
    start: new Date(2021, 6, 17, 18, 0, 0, 0),
    end: new Date(2021, 6, 17, 21, 0, 0, 0),
  },
  {
    id: 17,
    title: "Flights Restaurant, 165 Los Gatos-Saratoga Rd. #5306,  Los Gatos, CA",
    start: new Date(2021, 6, 31, 18, 0, 0, 0),
    end: new Date(2021, 6, 31, 21, 0, 0, 0),
  },
  {
    id: 18,
    title: "Casa Orozco, 7995 Amador Valley Blvd.,  Dublin, CA",
    start: new Date(2021, 7, 14, 18, 0, 0, 0),
    end: new Date(2021, 7, 14, 21, 30, 0, 0),
  },
  {
    id: 19,
    title: "Casa Orozco, 7995 Amador Valley Blvd.,  Dublin, CA",
    start: new Date(2021, 8, 11, 18, 0, 0, 0),
    end: new Date(2021, 8, 11, 21, 30, 0, 0),
  },
  {
    id: 20,
    title: "San Francisco Brewery, 3150 Polk St,  San Francisco, CA",
    start: new Date(2021, 7, 7, 15, 0, 0, 0),
    end: new Date(2021, 7, 7, 18, 0, 0, 0),
  },
  {
    id: 22,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2021, 5, 6, 14, 0, 0, 0),
    end: new Date(2021, 5, 6, 17, 0, 0, 0),
  },
  {
    id: 23,
    title: "Alice’s Restaurant, 17288 Skyline Blvd.,  Woodside, CA",
    start: new Date(2021, 4, 27, 17, 0, 0, 0),
    end: new Date(2021, 4, 27, 19, 0, 0, 0),
  },
  {
    id: 24,
    title: "Mountain View Farmers Market, 650 W. Evelyn Ave.,  Mountain View, CA",
    start: new Date(2021, 8, 26, 9, 0, 0, 0),
    end: new Date(2021, 8, 26, 13, 0, 0, 0),
  },
  {
    id: 25,
    title: "Winters Tavern, 1522 Francisco Blvd.,  Pacifica, CA",
    start: new Date(2021, 8, 19, 16, 0, 0, 0),
    end: new Date(2021, 8, 19, 19, 0, 0, 0),
  },
  {
    id: 26,
    title: "Private Party,  Redwood City, CA",
    start: new Date(2021, 4, 22, 18, 0, 0, 0),
    end: new Date(2021, 4, 22, 21, 0, 0, 0)
  },
  {
    id: 27,
    title: "Auburn Lounge, 321 Hartz Ave., #3336,  Danville, CA",
    start: new Date(2021, 7, 8, 14, 0, 0, 0),
    end: new Date(2021, 7, 8, 17, 0, 0, 0),
  },
  {
    id: 29,
    title: "Pioneer Saloon, 2925 Woodside Road,  Woodside, California",
    start: new Date(2021, 6, 11, 16, 0, 0, 0),
    end: new Date(2021, 6, 11, 19, 0, 0, 0),
  },
  {
    id: 30,
    title: "College of San Mateo Farmers Market, 1700 W. Hillsdale Blvd.,  San Mateo, California",
    start: new Date(2021, 7, 21, 9, 0, 0, 0),
    end: new Date(2021, 7, 21, 13, 0, 0, 0),
  },
  {
    id: 31,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2021, 8, 5, 14, 0, 0, 0),
    end: new Date(2021, 8, 5, 17, 0, 0, 0),
  },
  {
    id: 32,
    title: "Private Party,  Half Moon Bay, CA",
    start: new Date(2021, 11, 11, 19, 0, 0, 0),
    end: new Date(2021, 11, 11, 22, 0, 0, 0),
  },
  {
    id: 33,
    title: "Main Street Brewery, 830 Main St,  Pleasanton, CA",
    start: new Date(2021, 5, 27, 14, 0, 0, 0),
    end: new Date(2021, 5, 27, 17, 0, 0, 0),
  },
  {
    id: 34,
    title: "End of Summer Celebration, Town Plaza and Montebello Way,  Los Gatos, CA",
    start: new Date(2021, 8, 4, 13, 30, 0, 0),
    end: new Date(2021, 8, 4, 15, 30, 0, 0)
  },
  {
    id: 35,
    title: "Private Party,  Redwood City, CA",
    start: new Date(2021, 9, 31, 16, 0, 0, 0),
    end: new Date(2021, 9, 31, 19, 0, 0, 0)
  },
  {
    id: 38,
    title: "Italian American Social Club (Dinner and Dance), 100 N B St.,  San Mateo, CA",
    start: new Date(2021, 10, 5, 18, 0, 0, 0),
    end: new Date(2021, 10, 5, 23, 0, 0, 0)
  },
  {
    id: 39,
    title: "The Office, 1748 El Camino Real,  San Carlos, CA",
    start: new Date(2021, 9, 2, 20, 0, 0, 0),
    end: new Date(2021, 9, 2, 23, 0, 0, 0)
  },
  {
    id: 40,
    title: "Highway 1 Brewing Company, 5720 CA-1,  Pescadero, CA",
    start: new Date(2021, 9, 10, 13, 30, 0, 0),
    end: new Date(2021, 9, 10, 16, 30, 0, 0)
  },
  {
    id: 41,
    title: "Off the Rails Brewing Company, 11 S Murphy Ave.,  Sunnyvale, CA",
    start: new Date(2021, 8, 25, 18, 0, 0, 0),
    end: new Date(2021, 8, 25, 21, 0, 0, 0)
  },
  {
    id: 42,
    title: "Spin a Yarn Steakhouse, 45915 Warm Springs Blvd.,  Fremont, CA",
    start: new Date(2021, 8, 10, 19, 0, 0, 0),
    end: new Date(2021, 8, 10, 22, 0, 0, 0)
  },
  {
    id: 43,
    title: "Alice’s Restaurant, 17288 Skyline Blvd.,  Woodside, CA",
    start: new Date(2021, 10, 4, 17, 0, 0, 0),
    end: new Date(2021, 10, 4, 19, 0, 0, 0)
  },
  {
    id: 44,
    title: "Freewheel Brewing Company, 3736 Florence St.,  Redwood City, CA",
    start: new Date(2021, 9, 23, 18, 0, 0, 0),
    end: new Date(2021, 9, 23, 20, 0, 0, 0)
  },
  {
    id: 45,
    title: "American Legion Half Moon Bay, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2021, 10, 21, 13, 0, 0, 0),
    end: new Date(2021, 10, 21, 16, 0, 0, 0)
  },
  {
    id: 46,
    title: "Pioneer Saloon, 2925 Woodside Rd.,  Woodside, CA",
    start: new Date(2021, 9, 3, 16, 0, 0, 0),
    end: new Date(2021, 9, 3, 19, 0, 0, 0)
  },
  {
    id: 47,
    title: "Pioneer Saloon, 2925 Woodside Rd.,  Woodside, CA",
    start: new Date(2021, 11, 5, 16, 0, 0, 0),
    end: new Date(2021, 11, 5, 19, 0, 0, 0)
  },
  {
    id: 48,
    title: "The Office Bar & Grill, 1748 El Camino Real,  San Carlos, CA",
    start: new Date(2021, 10, 13, 20, 0, 0, 0),
    end: new Date(2021, 10, 13, 23, 0, 0, 0)
  },
  {
    id: 49,
    title: "Spin a Yarn Steakhouse, 45915 Warm Springs Rd.,  Fremont, CA",
    start: new Date(2021, 9, 22, 19, 0, 0, 0),
    end: new Date(2021, 9, 22, 22, 0, 0, 0)
  },
  {
    id: 50,
    title: "Casa Orozco, 7995 Amador Valley Blvd.,  Dublin, CA",
    start: new Date(2021, 11, 4, 17, 30, 0, 0),
    end: new Date(2021, 11, 4, 21, 0, 0, 0)
  },
  {
    id: 51,
    title: "Private Holiday Party,  Burlingame, CA",
    start: new Date(2021, 11, 15, 18, 0, 0, 0),
    end: new Date(2021, 11, 15, 21, 0, 0, 0)
  },
  {
    id: 52,
    title: "Mountain View Farmers Market, 600 West Evelyn Ave.,  Mountain View, CA",
    start: new Date(2022, 2, 27, 9, 0, 0, 0),
    end: new Date(2022, 2, 27, 13, 0, 0, 0)
  },
  {
    id: 53,
    title: "Peninsula Italian American Social Club, 100 N.B Street,  San Mateo, CA",
    start: new Date(2022, 4, 6, 19, 30, 0, 0),
    end: new Date(2022, 4, 6, 22, 30, 0, 0)
  },
  {
    id: 54,
    title: "Saratoga Farmers Market, 14000 Fruitvale Ave.,  Saratoga, CA",
    start: new Date(2022, 7, 20, 9, 0, 0, 0),
    end: new Date(2022, 7, 20, 13, 0, 0, 0)
  },
  {
    id: 55,
    title: "American Legion Half Moon Bay, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2022, 0, 23, 13, 0, 0, 0),
    end: new Date(2022, 0, 23, 16, 0, 0, 0)
  },
  {
    id: 56,
    title: "Casa Orozco, 7995 Amador Valley Blvd.,  Dublin, CA",
    start: new Date(2022, 1, 26, 17, 30, 0, 0),
    end: new Date(2022, 1, 26, 21, 0, 0, 0)
  },
  {
    id: 57,
    title: "College of San Mateo Farmers Market, 1700 W. Hillsdale Blvd.,  San Mateo, CA",
    start: new Date(2022, 4, 21, 9, 0, 0, 0),
    end: new Date(2022, 4, 21, 13, 0, 0, 0)
  },
  {
    id: 58,
    title: "College of San Mateo Farmers Market, 1700 W. Hillsdale Blvd.,  San Mateo, CA",
    start: new Date(2022, 8, 10, 9, 0, 0, 0),
    end: new Date(2022, 8, 10, 13, 0, 0, 0)
  },
  {
    id: 59,
    title: "Winters Tavern, 1522 Francisco Blvd.,  Pacifica, CA",
    start: new Date(2022, 1, 20, 14, 0, 0, 0),
    end: new Date(2022, 1, 20, 17, 0, 0, 0)
  },
  {
    id: 62,
    title: "Big Dog Vineyards, 4545 Felter Rd.,  Milpitas, CA",
    start: new Date(2022, 1, 12, 13, 30, 0, 0),
    end: new Date(2022, 1, 12, 16, 30, 0, 0)
  },
  {
    id: 63,
    title: "Private 70th Birthday Party,  Danville, CA",
    start: new Date(2022, 4, 22, 16, 30, 0, 0),
    end: new Date(2022, 4, 22, 19, 30, 0, 0)
  },
  {
    id: 64,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2022, 2, 12, 13, 0, 0, 0),
    end: new Date(2022, 2, 12, 16, 0, 0, 0)
  },
  {
    id: 65,
    title: "S27 Brewery, 461 Perrymont Ave.,  San Jose, CA",
    start: new Date(2022, 2, 19, 17, 30, 0, 0),
    end: new Date(2022, 2, 19, 20, 30, 0, 0)
  },
  {
    id: 66,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2022, 3, 10, 14, 0, 0, 0),
    end: new Date(2022, 3, 10, 17, 0, 0, 0)
  },
  {
    id: 67,
    title: "Elevation LVK, 682 Terminal Cir.,  Livermore, CA",
    start: new Date(2022, 6, 16, 18, 30, 0, 0),
    end: new Date(2022, 6, 16, 21, 30, 0, 0)
  },
  {
    id: 69,
    title: "The Office Bar and Grill, 1748 El Camino Real,  San Carlos, CA",
    start: new Date(2022, 3, 23, 20, 0, 0, 0),
    end: new Date(2022, 3, 23, 23, 0, 0, 0)
  },
  {
    id: 70,
    title: "Bent Creek Winery, 5455 Greenville Rd.,  Livermore, CA",
    start: new Date(2022, 4, 8, 12, 0, 0, 0),
    end: new Date(2022, 4, 8, 16, 0, 0, 0)
  },
  {
    id: 71,
    title: "The Florence, 37349 Niles Blvd.,  Fremont, CA",
    start: new Date(2022, 6, 10, 17, 0, 0, 0),
    end: new Date(2022, 6, 10, 21, 0, 0, 0)
  },
  {
    id: 72,
    title: "The Florence, 37349 Niles Blvd.,  Fremont, CA",
    start: new Date(2022, 9, 9, 17, 0, 0, 0),
    end: new Date(2022, 9, 9, 21, 0, 0, 0)
  },
  {
    id: 73,
    title: "Freewheel Brewing Company, 3736 Florence Street,  Redwood City, CA",
    start: new Date(2022, 5, 25, 19, 0, 0, 0),
    end: new Date(2022, 5, 25, 21, 0, 0, 0)
  },
  {
    id: 75,
    title: "Casa Orozco, 7995 Amador Valley Blvd.,  Dublin, CA",
    start: new Date(2022, 9, 15, 18, 0, 0, 0),
    end: new Date(2022, 9, 15, 21, 0, 0, 0)
  },
  {
    id: 77,
    title: "Alice's Restaurant, 17288 Skyline Blvd.,  Woodside, CA",
    start: new Date(2022, 6, 21, 17, 0, 0, 0),
    end: new Date(2022, 6, 21, 19, 30, 0, 0)
  },
  {
    id: 78,
    title: "P&V Winery, 10155 Dougherty Ave.,  Morgan Hill, CA",
    start: new Date(2022, 7, 6, 13, 0, 0, 0),
    end: new Date(2022, 7, 6, 16, 0, 0, 0)
  },
  {
    id: 79,
    title: "Winters Tavern 1522 Francisco Blvd.,  Pacifica, CA",
    start: new Date(2022, 5, 26, 15, 0, 0, 0),
    end: new Date(2022, 5, 26, 18, 0, 0, 0)
  },
  {
    id: 81,
    title: "San Pedro Square Market Bar, 87 N. Pedro St.,  San Jose, CA",
    start: new Date(2022, 4, 19, 18, 0, 0, 0),
    end: new Date(2022, 4, 19, 21, 0, 0, 0)
  },
  {
    id: 82,
    title: "The Club at Westpoint (Private Summer Concert),  Redwood City, CA",
    start: new Date(2022, 6, 30, 17, 0, 0, 0),
    end: new Date(2022, 6, 30, 20, 0, 0, 0)
  },
  {
    id: 83,
    title: "Steel Bonnett Brewing Company 20 Victor Square B,  Scotts Valley, CA",
    start: new Date(2022, 3, 30, 17, 0, 0, 0),
    end: new Date(2022, 3, 30, 20, 0, 0, 0)
  },
  {
    id: 84,
    title: "Highway 1 Brewing Company, 5720 Cabrillo Highway,  Pescadero, CA",
    start: new Date(2022, 7, 27, 13, 0, 0, 0),
    end: new Date(2022, 7, 27, 16, 0, 0, 0)
  },
  {
    id: 86,
    title: "Marvin Gardens, 1160 Old County Rd.,  Belmont, CA",
    start: new Date(2022, 4, 27, 18, 0, 0, 0),
    end: new Date(2022, 4, 27, 21, 0, 0, 0)
  },
  {
    id: 87,
    title: "Half Moon Bay 4th of July Town Picnic, American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2022, 6, 4, 14, 0, 0, 0),
    end: new Date(2022, 6, 4, 17, 0, 0, 0)
  },
  {
    id: 88,
    title: "Private Party,  Redwood City, CA",
    start: new Date(2022, 6, 23, 18, 0, 0, 0),
    end: new Date(2022, 6, 23, 21, 0, 0, 0)
  },
  {
    id: 89,
    title: "Marvin Gardens, 1160 Old County Rd.,  Belmont, CA",
    start: new Date(2022, 10, 4, 18, 0, 0, 0),
    end: new Date(2022, 10, 4, 21, 0, 0, 0)
  },
  {
    id: 90,
    title: "Costanoa Lodge, 2001 Rossi Rd.,  Pescadero, CA",
    start: new Date(2022, 10, 19, 16, 0, 0, 0),
    end: new Date(2022, 10, 19, 19, 0, 0, 0)
  },
  {
    id: 91,
    title: "Private Event, The Shack Riders,  Woodside CA",
    start: new Date(2022, 6, 31, 12, 0, 0, 0),
    end: new Date(2022, 6, 31, 15, 30, 0, 0)
  },
  {
    id: 92,
    title: "Elevation LVK, 680 Terminal Cir.,  Livermore, CA",
    start: new Date(2022, 10, 5, 18, 0, 0, 0),
    end: new Date(2022, 10, 5, 21, 0, 0, 0)
  },
  {
    id: 93,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2022, 10, 12, 19, 0, 0, 0),
    end: new Date(2022, 10, 12, 22, 0, 0, 0)
  },
  {
    id: 94,
    title: "Winters Tavern, 1522 Francisco Blvd.,  Pacifica, CA",
    start: new Date(2022, 11, 18, 14, 0, 0, 0),
    end: new Date(2022, 11, 18, 17, 0, 0, 0)
  },
  {
    id: 96,
    title: "Private Halloween Party,  Redwood City, CA",
    start: new Date(2022, 9, 31, 17, 0, 0, 0),
    end: new Date(2022, 9, 31, 20, 30, 0, 0)
  },
  {
    id: 97,
    title: "Apple Jacks, 8790 La Honda Rd.,  La Honda, CA",
    start: new Date(2022, 8, 11, 16, 20, 0, 0),
    end: new Date(2022, 8, 11, 20, 20, 0, 0)
  },
  {
    id: 98,
    title: "Alice’s Restaurant, 17288 Skyline Blvd.,  Woodside, CA",
    start: new Date(2022, 8, 22, 17, 0, 0, 0),
    end: new Date(2022, 8, 22, 19, 30, 0, 0)
  },
  {
    id: 99,
    title: "P&V Winery, 10155 Dougherty Ave.,  Morgan Hill, CA",
    start: new Date(2022, 9, 1, 13, 0, 0, 0),
    end: new Date(2022, 9, 1, 16, 0, 0, 0)
  },
  {
    id: 100,
    title: "SM Police Department Pink Patch Project Party, FREE Community Event to Support Breast Cancer, 11 W. Hillsdale Blvd.,  San Mateo, CA (Barnes and Noble Parking Lot at Hillsdale Mall)",
    start: new Date(2022, 9, 2, 11, 0, 0, 0),
    end: new Date(2022, 9, 2, 15, 0, 0, 0)
  },
  {
    id: 101,
    title: "Corporate Private Party, San Jose, CA",
    start: new Date(2022, 9, 6, 12, 0, 0, 0),
    end: new Date(2022, 9, 6, 14, 0, 0, 0)
  },
  {
    id: 102,
    title: "Casa Orozco, 7995 Amador Valley Blvd.,  Dublin, CA",
    start: new Date(2022, 8, 17, 17, 30, 0, 0),
    end: new Date(2022, 8, 17, 21, 0, 0, 0)
  },
  {
    id: 103,
    title: "San Pedro Square Market, 87 N San Pedro St.,  San Jose, CA",
    start: new Date(2022, 9, 21, 18, 0, 0, 0),
    end: new Date(2022, 9, 21, 21, 0, 0, 0)
  },
  {
    id: 104,
    title: "Casa Orozco, 325 S L St.,  Livermore, CA",
    start: new Date(2023, 0, 21, 18, 0, 0, 0),
    end: new Date(2023, 0, 21, 21, 0, 0, 0)
  },
  {
    id: 105,
    title: "The Tavern, 1015 Alameda de las Pulgas,  Belmont, CA",
    start: new Date(2023, 0, 28, 19, 0, 0, 0),
    end: new Date(2023, 0, 28, 22, 0, 0, 0)
  },
  {
    id: 106,
    title: "Marvin Gardens, 1160 Old County Rd.,  Belmont, CA",
    start: new Date(2023, 1, 10, 18, 0, 0, 0),
    end: new Date(2023, 1, 10, 21, 0, 0, 0)
  },
  {
    id: 107,
    title: "The Tavern, 1015 Alameda de las Pulgas,  Belmont, CA",
    start: new Date(2023, 1, 25, 19, 0, 0, 0),
    end: new Date(2023, 1, 25, 22, 0, 0, 0)
  },
  {
    id: 108,
    title: "Mountain View Farmers Market, 600 W Evelyn Ave.,  Mountain View, CA",
    start: new Date(2023, 2, 26, 9, 0, 0, 0),
    end: new Date(2023, 2, 26, 13, 0, 0, 0)
  },
  {
    id: 109,
    title: "Peninsula Italian American Social Club, 100 N B St.,  San Mateo, CA",
    start: new Date(2023, 6, 7, 19, 30, 0, 0),
    end: new Date(2023, 6, 7, 22, 30, 0, 0)
  },
  {
    id: 110,
    title: "Saratoga Farmers Market (West Valley College), 14000 Fruitvale Ave.,  Saratoga, CA",
    start: new Date(2023, 7, 19, 9, 0, 0, 0),
    end: new Date(2023, 7, 19, 13, 0, 0, 0)
  },
  {
    id: 110,
    title: "Private Event,  Sunnyvale, CA",
    start: new Date(2022, 11, 3, 18, 0, 0, 0),
    end: new Date(2022, 11, 3, 21, 0, 0, 0)
  },
  {
    id: 112,
    title: "Pioneer Saloon, 2925 Woodside Rd.,  Woodside, CA",
    start: new Date(2023, 4, 21, 16, 0, 0, 0),
    end: new Date(2023, 4, 21, 19, 0, 0, 0)
  },
  {
    id: 113,
    title: "The Office Bar and Grill, 1748 El Camino Real,  San Carlos, CA",
    start: new Date(2023, 3, 8, 20, 0, 0, 0),
    end: new Date(2023, 3, 8, 23, 0, 0, 0)
  },
  {
    id: 114,
    title: "Davenport Roadhouse, 1 Davenport Ave.,  Davenport, CA",
    start: new Date(2023, 3, 16, 13, 0, 0, 0),
    end: new Date(2023, 3, 16, 16, 0, 0, 0)
  },
  {
    id: 115,
    title: "P&V Winery Dance Party, 10155 Dougherty Ave., Morgan Hill, CA",
    start: new Date(2023, 5, 3, 18, 30, 0, 0),
    end: new Date(2023, 5, 3, 21, 30, 0, 0)
  },
  {
    id: 117,
    title: "College of San Mateo Farmers Market, 1700 W Hillsdale Blvd.,  San Mateo, CA",
    start: new Date(2023, 3, 22, 9, 0, 0, 0),
    end: new Date(2023, 3, 22, 13, 0, 0, 0)
  },
  {
    id: 119,
    title: "College of San Mateo Farmers Market, 1700 W Hillsdale Blvd.,  San Mateo, CA",
    start: new Date(2023, 9, 14, 9, 0, 0, 0),
    end: new Date(2023, 9, 14, 13, 0, 0, 0)
  },
  {
    id: 120,
    title: "Caso Orozco, 7995 Amador Valley Blvd.,  Dublin, CA",
    start: new Date(2023, 4, 13, 18, 0, 0, 0),
    end: new Date(2023, 4, 13, 21, 0, 0, 0)
  },
  {
    id: 121,
    title: "Downtown Los Altos First Friday @ Adventure Toys, 173 Main St.,  Los Altos, CA.",
    start: new Date(2023, 2, 3, 18, 0, 0, 0),
    end: new Date(2023, 2, 3, 20, 0, 0, 0)
  },
  {
    id: 123,
    title: "The Cats Restaurant, 17533 Santa Cruz Hwy.,  Los Gatos, CA",
    start: new Date(2023, 3, 1, 19, 0, 0, 0),
    end: new Date(2023, 3, 1, 22, 0, 0, 0)
  },
  {
    id: 124,
    title: "Costanoa Lodge, 2001 Rossi Rd.,  Pescadero, CA",
    start: new Date(2023, 5, 10, 17, 0, 0, 0),
    end: new Date(2023, 5, 10, 20, 0, 0, 0)
  },
  {
    id: 125,
    title: "Costanoa Lodge, 2001 Rossi Rd.,  Pescadero, CA",
    start: new Date(2023, 7, 5, 17, 0, 0, 0),
    end: new Date(2023, 7, 5, 20, 0, 0, 0)
  },
  {
    id: 126,
    title: "Alice's Restaurant, 17288 Skyline Blvd.,  Woodside, CA",
    start: new Date(2023, 5, 29, 17, 0, 0, 0),
    end: new Date(2023, 5, 29, 19, 30, 0, 0)
  },
  {
    id: 127,
    title: "Alice's Restaurant, 17288 Skyline Blvd.,  Woodside, CA",
    start: new Date(2023, 7, 31, 17, 0, 0, 0),
    end: new Date(2023, 7, 31, 19, 30, 0, 0)
  },
  {
    id: 128,
    title: "Marvin Gardens, 1160 Old County Rd.,  Belmont, CA",
    start: new Date(2023, 5, 23, 18, 0, 0, 0),
    end: new Date(2023, 5, 23, 21, 0, 0, 0)
  },
  {
    id: 131,
    title: "Elevation LVK, 682 Terminal Circle,  Livermore, CA",
    start: new Date(2023, 7, 12, 18, 0, 0, 0),
    end: new Date(2023, 7, 12, 21, 0, 0, 0)
  },
  {
    id: 132,
    title: "Private Party,  Redwood City, California",
    start: new Date(2023, 8, 16, 18, 0, 0, 0),
    end: new Date(2023, 8, 16, 21, 0, 0, 0)
  },
  {
    id: 134,
    title: "Las Positas Vineyards 1828 Wetmore Rd.,  Livermore, California",
    start: new Date(2023, 8, 30, 18, 0, 0, 0),
    end: new Date(2023, 8, 30, 20, 30, 0, 0)
  },
  {
    id: 135,
    title: "First Friday Downtown Los Altos @ Hyper Space, 127 First Street,  Los Altos, CA",
    start: new Date(2023, 5, 2, 18, 0, 0, 0),
    end: new Date(2023, 5, 2, 21, 0, 0, 0)
  },
  {
    id: 136,
    title: "Private Event",
    start: new Date(2023, 9, 7, 12, 0, 0, 0),
    end: new Date(2023, 9, 7, 23, 59, 0, 0)
  },
  {
    id: 137,
    title: "Menlo Tavern @ The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2023, 6, 15, 18, 0, 0, 0),
    end: new Date(2023, 6, 15, 21, 0, 0, 0)
  },
  {
    id: 138,
    title: "Private Event,  Woodside, CA",
    start: new Date(2023, 5, 25, 12, 0, 0, 0),
    end: new Date(2023, 5, 25, 15, 30, 0, 0)
  },
  {
    id: 141,
    title: "Par 3 Restaurant at Poplar Creek Golf Course, 1700 Coyote Point Dr.,  San Mateo, California",
    start: new Date(2023, 11, 15, 18, 0, 0, 0),
    end: new Date(2023, 11, 15, 21, 0, 0, 0)
  },
  {
    id: 142,
    title: "Peninsula Italian American Social Club, 100 North B. St.,  San Mateo, CA",
    start: new Date(2024, 1, 2, 19, 0, 0, 0),
    end: new Date(2024, 1, 2, 22, 0, 0, 0)
  },
  {
    id: 143,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2024, 3, 14, 13, 0, 0, 0),
    end: new Date(2024, 3, 14, 16, 0, 0, 0)
  },
  {
    id: 144,
    title: "Peninsula Italian American Social Club, 100 North B.St.,  San Mateo, CA",
    start: new Date(2024, 5, 7, 19, 0, 0, 0),
    end: new Date(2024, 5, 7, 22, 0, 0, 0)
  },
  {
    id: 146,
    title: "Los Positas Winery, 1828 Wetmore Rd.,  Livermore, CA",
    start: new Date(2024, 5, 29, 18, 0, 0, 0),
    end: new Date(2024, 5, 29, 20, 30, 0, 0)
  },
  {
    id: 147,
    title: "Private Event,  San Bruno, CA",
    start: new Date(2024, 7, 31, 20, 0, 0, 0),
    end: new Date(2024, 7, 31, 23, 0, 0, 0)
  },
  {
    id: 148,
    title: "Private Event,  San Carlos, CA",
    start: new Date(2024, 5, 8, 20, 0, 0, 0),
    end: new Date(2024, 5, 8, 23, 0, 0, 0)
  },
  {
    id: 149,
    title: "Menlo Park Tavern at The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2024, 4, 18, 18, 0, 0, 0),
    end: new Date(2024, 4, 18, 21, 0, 0, 0)
  },
  {
    id: 150,
    title: "Menlo Park Tavern at The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2024, 5, 15, 18, 0, 0, 0),
    end: new Date(2024, 5, 15, 21, 0, 0, 0)
  },
  {
    id: 151,
    title: "Menlo Park Tavern at The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2024, 6, 27, 18, 0, 0, 0),
    end: new Date(2024, 6, 27, 21, 0, 0, 0)
  },
  {
    id: 152,
    title: "Menlo Park Tavern at The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2024, 7, 10, 18, 0, 0, 0),
    end: new Date(2024, 7, 10, 21, 0, 0, 0)
  },
  {
    id: 153,
    title: "Menlo Park Tavern at The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2024, 8, 7, 18, 0, 0, 0),
    end: new Date(2024, 8, 7, 21, 0, 0, 0)
  },
  {
    id: 156,
    title: "Old Greenwood BBQ at The Gold Rush Saloon at Sunken Gardens Golf Course, 1010 South Wolfe Rd.,  Sunnyvale, CA",
    start: new Date(2024, 8, 28, 18, 0, 0, 0),
    end: new Date(2024, 8, 28, 21, 0, 0, 0)
  },
  {
    id: 157,
    title: "Private Party,  Woodside, CA",
    start: new Date(2024, 2, 9, 19, 0, 0, 0),
    end: new Date(2024, 2, 9, 22, 0, 0, 0)
  },
  {
    id: 158,
    title: "Private Holiday Party,  South San Francisco, CA",
    start: new Date(2024, 11, 7, 18, 0, 0, 0),
    end: new Date(2024, 11, 7, 23, 0, 0, 0)
  },
  {
    id: 159,
    title: "Private Party,  Danville, CA",
    start: new Date(2024, 7, 24, 18, 0, 0, 0),
    end: new Date(2024, 7, 24, 21, 0, 0, 0)
  },
  {
    id: 160,
    title: "Par 3 Restaurant at Poplar Creek Golf Course, 1700 Coyote Point Dr.,  San Mateo, California",
    start: new Date(2024, 3, 19, 18, 0, 0, 0),
    end: new Date(2024, 3, 19, 21, 0, 0, 0)
  },
  {
    id: 161,
    title: "Casa Orozco, 7995 Amador Valley Blvd,  Dublin, CA",
    start: new Date(2024, 4, 4, 18, 0, 0, 0),
    end: new Date(2024, 4, 4, 21, 0, 0, 0)
  },
  {
    id: 162,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2024, 7, 4, 13, 0, 0, 0),
    end: new Date(2024, 7, 4, 16, 0, 0, 0)
  },
  {
    id: 163,
    title: "Par 3 Restaurant at Poplar Creek Golf Course, 1700 Coyote Point Dr.,  San Mateo, California",
    start: new Date(2024, 7, 16, 18, 0, 0, 0),
    end: new Date(2024, 7, 16, 21, 0, 0, 0)
  },
  {
    id: 164,
    title: "Alice's Restaurant 17288 Skyline Blvd.,  Woodside, CA",
    start: new Date(2024, 6, 3, 17, 0, 0, 0),
    end: new Date(2024, 6, 3, 19, 30, 0, 0)
  },
  {
    id: 165,
    title: "Private Event/Basque Cultural Center Holiday Party, 559 Railroad Ave.,  South San Francisco, CA599",
    start: new Date(2024, 11, 6, 20, 30, 0, 0),
    end: new Date(2024, 11, 6, 23, 30, 0, 0)
  },
  {
    id: 166,
    title: "Private Party,  Woodside, CA",
    start: new Date(2024, 6, 28, 12, 30, 0, 0),
    end: new Date(2024, 6, 28, 15, 30, 0, 0)
  },
  {
    id: 168,
    title: "Par 3 Restaurant @ Poplar Creek Golf Course, 1700 Coyote Point Dr.,  San Mateo, CA",
    start: new Date(2024, 8, 13, 18, 0, 0, 0),
    end: new Date(2024, 8, 13, 21, 0, 0, 0)
  },
  {
    id: 170,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2024, 10, 23, 13, 0, 0, 0),
    end: new Date(2024, 10, 23, 16, 0, 0, 0)
  },
  {
    id: 172,
    title: "Private 70th Birthday Party,  Redwood City, CA",
    start: new Date(2025, 1, 1, 18, 0, 0, 0),
    end: new Date(2025, 1, 1, 22, 0, 0, 0)
  },
  {
    id: 173,
    title: "Peninsula Italian American Social Club, 101 N. B St.,  San Mateo, CA",
    start: new Date(2025, 7, 1, 19, 30, 0, 0),
    end: new Date(2025, 7, 1, 22, 30, 0, 0)
  },
  {
    id: 174,
    title: "Private Event,  Woodside, CA",
    start: new Date(2024, 11, 29, 19, 0, 0, 0),
    end: new Date(2024, 11, 29, 22, 0, 0, 0)
  },
  {
    id: 175,
    title: "Elks Lodge, 920 Stonegate Drive,  South San Francisco, CA",
    start: new Date(2024, 11, 31, 19, 0, 0, 0),
    end: new Date(2024, 11, 31, 23, 59, 0, 0)
  },
  {
    id: 177,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2025, 4, 11, 13, 0, 0, 0),
    end: new Date(2025, 4, 11, 16, 0, 0, 0)
  },
  {
    id: 178,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2025, 5, 29, 13, 0, 0, 0),
    end: new Date(2025, 5, 29, 16, 0, 0, 0)
  },
  {
    id: 179,
    title: "LaNebbia Winery, 12341 San Mateo Rd.  Half Moon Bay, CA",
    start: new Date(2025, 3, 13, 13, 0, 0, 0),
    end: new Date(2025, 3, 13, 16, 0, 0, 0)
  },
  {
    id: 180,
    title: "Old Greenwood BBQ at the Gold Rush Saloon @ Sunken Gardens Golf Course, 1010 S Wolfe Rd,  Sunnyvale, CA",
    start: new Date(2025, 7, 30, 18, 0, 0, 0),
    end: new Date(2025, 7, 30, 21, 0, 0, 0)
  },
  {
    id: 181,
    title: "Private Party,  Saratoga, CA",
    start: new Date(2025, 6, 25, 19, 0, 0, 0),
    end: new Date(2025, 6, 25, 21, 30, 0, 0)
  },
  {
    id: 183,
    title: "The Menlo Tavern @ The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2025, 6, 19, 18, 0, 0, 0),
    end: new Date(2025, 6, 19, 21, 0, 0, 0)
  },
  {
    id: 184,
    title: "The Menlo Tavern @ The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2025, 7, 23, 18, 0, 0, 0),
    end: new Date(2025, 7, 23, 21, 0, 0, 0)
  },
  {
    id: 184,
    title: "The Menlo Tavern @ The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2025, 8, 13, 18, 0, 0, 0),
    end: new Date(2025, 8, 13, 21, 0, 0, 0)
  },
  {
    id: 185,
    title: "The Menlo Tavern @ The Stanford Park Hotel, 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2025, 9, 25, 18, 0, 0, 0),
    end: new Date(2025, 9, 25, 21, 0, 0, 0)
  },
  {
    id: 186,
    title: "Peninsula Italian American Social Club, 100 N B St,  San Mateo, CA",
    start: new Date(2025, 10, 7, 19, 0, 0, 0),
    end: new Date(2025, 10, 7, 22, 30, 0, 0)
  },
  {
    id: 187,
    title: "Los Positas Vineyard, 1828 Wetmore Rd,  Livermore, CA",
    start: new Date(2025, 10, 22, 18, 0, 0, 0),
    end: new Date(2025, 10, 22, 20, 30, 0, 0)
  },
  {
    id: 188,
    title: "Edgewater Marina (Ribbon Cutting and New Boat Launch), 1001 Bountry Dr.,  Foster, City CA",
    start: new Date(2025, 4, 16, 17, 0, 0, 0),
    end: new Date(2025, 4, 16, 19, 0, 0, 0)
  },
  {
    id: 189,
    title: "Private Party,  Danville, CA",
    start: new Date(2025, 9, 4, 16, 0, 0, 0),
    end: new Date(2025, 9, 4, 19, 0, 0, 0)
  },
  {
    id: 190,
    title: "Private Event,  Woodside, CA",
    start: new Date(2025, 5, 22, 13, 0, 0, 0),
    end: new Date(2025, 5, 22, 16, 0, 0, 0)
  },
  {
    id: 191,
    title: "American Legion Half Moon Bay, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2025, 11, 7, 13, 0, 0, 0),
    end: new Date(2025, 11, 7, 16, 0, 0, 0)
  },
  {
    id: 192,
    title: "Bridal up Hope Foundation, 12675 Mt. Hamilton Rd.,  San Jose, CA",
    start: new Date(2025, 9, 11, 17, 0, 0, 0),
    end: new Date(2025, 9, 11, 21, 0, 0, 0)
  },
  {
    id: 193,
    title: "Los Positas Vineyard, 1828 Wetmore Rd,  Livermore, CA",
    start: new Date(2026, 0, 10, 18, 0, 0, 0),
    end: new Date(2026, 0, 10, 20, 30, 0, 0)
  },
  {
    id: 194,
    title: "Satori Cellars, 2100 Buena Vista Ave.,  Gilroy CA",
    start: new Date(2025, 11, 13, 13, 30, 0, 0),
    end: new Date(2025, 11, 13, 16, 30, 0, 0)
  },
  {
    id: 195,
    title: "American Legion 470 Princeton Dr.,  Half Moon Bay, California",
    start: new Date(2025, 10, 9, 14, 0, 0, 0),
    end: new Date(2025, 10, 9, 17, 0, 0, 0)
  },
  {
    id: 196,
    title: "American Legion 470 Princeton Dr.,  Half Moon Bay, California",
    start: new Date(2026, 2, 28, 14, 0, 0, 0),
    end: new Date(2026, 2, 28, 17, 0, 0, 0)
  },
  {
    id: 197,
    title: "Peninsula Italian American Social Club, 100 North B St.,  San Mateo, CA",
    start: new Date(2026, 5, 5, 19, 30, 0, 0),
    end: new Date(2026, 5, 5, 22, 30, 0, 0)
  },
  {
    id: 198,
    title: "Private 50th Anniversary Party,  Palo Alto, CA",
    start: new Date(2026, 0, 24, 18, 0, 0, 0),
    end: new Date(2026, 0, 24, 21, 0, 0, 0)
  },
  {
    id: 199,
    title: "San Pedro Square Market, 87 N San Pedro St.,  San Jose, CA",
    start: new Date(2026, 2, 15, 13, 0, 0, 0),
    end: new Date(2026, 2, 15, 16, 0, 0, 0)
  },
  {
    id: 200,
    title: "The Menlo Tavern (Stanford Park Hotel), 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2026, 4, 16, 18, 0, 0, 0),
    end: new Date(2026, 4, 16, 21, 0, 0, 0)
  },
  {
    id: 201,
    title: "The Menlo Tavern (Stanford Park Hotel), 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2026, 5, 6, 18, 0, 0, 0),
    end: new Date(2026, 5, 6, 21, 0, 0, 0)
  },
  {
    id: 202,
    title: "The Menlo Tavern (Stanford Park Hotel), 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2026, 6, 11, 18, 0, 0, 0),
    end: new Date(2026, 6, 11, 21, 0, 0, 0)
  },
  {
    id: 203,
    title: "The Menlo Tavern (Stanford Park Hotel), 100 El Camino Real,  Menlo Park, CA",
    start: new Date(2026, 7, 15, 18, 0, 0, 0),
    end: new Date(2026, 7, 15, 21, 0, 0, 0)
  },
  // //jeb {
  //   id: 204,
  //   title: "The Menlo Tavern (Stanford Park Hotel), 100 El Camino Real,  Menlo Park, CA",
  //   start: new Date(2026, 8, 12, 18, 0, 0, 0),
  //   end: new Date(2026, 8, 12, 21, 0, 0, 0)
  // },
  {
    id: 206,
    title: "Satori Cellars, 2100 Buena Vista Ave.,  Gilroy, CA",
    start: new Date(2026, 6, 18, 13, 30, 0, 0),
    end: new Date(2026, 6, 18, 16, 30, 0, 0)
  },
  {
    id: 207,
    title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2026, 7, 2, 14, 0, 0, 0),
    end: new Date(2026, 7, 2, 17, 0, 0, 0)
  },
  // //jeb {
  //   id: 208,
  //   title: "American Legion, 470 Capistrano Rd.,  Half Moon Bay, CA",
  //   start: new Date(2026, 8, 13, 14, 0, 0, 0),
  //   end: new Date(2026, 8, 13, 17, 0, 0, 0)
  // },
  {
    id: 209,
    title: "Pioneer Saloon, 2925, Woodside Rd.,  Woodside, CA",
    start: new Date(2026, 9, 11, 16, 0, 0, 0),
    end: new Date(2026, 9, 11, 19, 0, 0, 0)
  },
  // //jeb {
  //   id: 210,
  //   title: "Belmont Centennial Celebration,  Belmont, CA",
  //   start: new Date(2026, 9, 24, 12, 0, 0, 0),
  //   end: new Date(2026, 9, 24, 14, 0, 0, 0)
  // },
  {
    id: 211,
    title: "Private Charity Event,  San Jose, CA",
    start: new Date(2026, 8, 19, 17, 0, 0, 0),
    end: new Date(2026, 8, 19, 21, 0, 0, 0)
  },
  {
    id: 212,
    title: "American Legion Half Moon Bay - 470 Capistrano Rd.,  Half Moon Bay, CA",
    start: new Date(2026, 11, 6, 14, 0, 0, 0),
    end: new Date(2026, 11, 6, 17, 0, 0, 0)
  },
  {
    id: 213,
    title: "Coyote Point Yacht Club, 1820 Coyote Point Dr.,  San Mateo, CA",
    start: new Date(2026, 7, 21, 18, 30, 0, 0),
    end: new Date(2026, 7, 21, 21, 30, 0, 0)
  },
  {
    id: 214,
    title: "Private Halloween Party,  Redwood City, CA",
    start: new Date(2026, 9, 31, 18, 0, 0, 0),
    end: new Date(2026, 9, 31, 21, 0, 0, 0)
  }
];     

/*
  ADDING EVENTS:

  * Subtract 1 from Months | January = 0 
  * Add a Double Space "  " before the City, State
  * If a new venue is added, update /venues.html

  * After making changes to this file:
    1. Open a command line to /calendar-app and run "npm run build"
    2. This will create a new file: /js/main.XXX.js
    3. Open /calendar.html, scroll to the bottom, and replace the XXX with the new hash
    4. You should now be able to see the new event on the calendar page
*/